import { cn } from '@/lib/utils';

import { TextArea, type TextAreaProps } from '../TextArea';

const InputGroupTextArea = ({ className, ...props }: TextAreaProps) => {
  return (
    <TextArea
      data-slot="input-group-control"
      className={cn(
        'min-w-0 flex-1 resize-none rounded-none border-0 bg-transparent shadow-none ring-0 focus:border-transparent focus:ring-0 disabled:bg-transparent',
        'focus:shadow-none data-invalid:border-0 data-warning:border-0',
        className,
      )}
      {...props}
    />
  );
};

export default InputGroupTextArea;
